<div class="w-full flex flex-col gap-lg" [formGroup]="formGroup">
    <div *ngIf="showAddPetTitle" class="text-md font-semibold text-text-primary">Add a Pet</div>

    <!-- Pet Name -->
    <hlm-form-field
        label="Pet Name"
        labelFor="name"
        class="w-full [&_.label]:text-sm [&_.label]:font-semibold [&_.label]:text-text-primary"
        [required]="true"
    >
        <input id="name" hlmInput type="text" maxlength="80" autocomplete="off" formControlName="name" />
        <hlm-error>Please enter a valid pet name</hlm-error>
    </hlm-form-field>

    <!-- Pet Type -->
    <hlm-form-field
        label="Pet Type"
        labelFor="petType"
        class="w-full [&_.label]:text-sm [&_.label]:font-semibold [&_.label]:text-text-primary"
        [required]="true"
    >
        <hlm-select
            id="petType"
            class="w-full"
            formControlName="petType"
            placeholder="Select a pet type"
            [compareWith]="comparePetTypeOptions"
            (valueChange)="petTypeChange($event)"
        >
            <hlm-select-trigger class="w-full">
                <hlm-select-value></hlm-select-value>
            </hlm-select-trigger>

            <hlm-select-content class="max-h-60">
                <hlm-select-scroll-up />
                <hlm-option *ngFor="let petType of petTypeList" [value]="petType">
                    {{ petType.name }}
                </hlm-option>
                <hlm-select-scroll-down />
            </hlm-select-content>
        </hlm-select>
        <hlm-error>Please select a pet type</hlm-error>
    </hlm-form-field>

    <!-- Pet Breed (conditional) -->
    <hlm-form-field
        *ngIf="petBreedList.length > 0"
        label="Pet Breed"
        labelFor="petBreed"
        class="w-full [&_.label]:text-sm [&_.label]:font-semibold [&_.label]:text-text-primary"
        [required]="true"
    >
        <hlm-select
            id="petBreed"
            class="w-full"
            formControlName="petBreed"
            placeholder="Select a pet breed"
            [compareWith]="comparePetBreedOptions"
        >
            <hlm-select-trigger class="w-full">
                <hlm-select-value></hlm-select-value>
            </hlm-select-trigger>

            <hlm-select-content class="max-h-60">
                <hlm-select-scroll-up />
                <hlm-option *ngFor="let petBreed of petBreedList" [value]="petBreed">
                    {{ petBreed.name }}
                </hlm-option>
                <hlm-select-scroll-down />
            </hlm-select-content>
        </hlm-select>
        <hlm-error>Please select a pet breed</hlm-error>
    </hlm-form-field>

    <!-- Pet Weight -->
    <hlm-form-field
        label="Pet Weight"
        labelFor="weight"
        class="w-full [&_.label]:text-sm [&_.label]:font-semibold [&_.label]:text-text-primary"
        [required]="true"
    >
        <hlm-select id="weight" class="w-full" formControlName="weight" placeholder="Select a weight range">
            <hlm-select-trigger class="w-full">
                <hlm-select-value></hlm-select-value>
            </hlm-select-trigger>

            <hlm-select-content>
                <hlm-option value="0 – 20 lbs">0 – 20 lbs</hlm-option>
                <hlm-option value="21 – 45 lbs">21 – 45 lbs</hlm-option>
                <hlm-option value="46 – 75 lbs">46 – 75 lbs</hlm-option>
                <hlm-option value="76 or more lbs">76 or more lbs</hlm-option>
            </hlm-select-content>
        </hlm-select>
        <hlm-error>Please select a weight range</hlm-error>
    </hlm-form-field>
</div>
